<template>
  <div id="articlehead">
    <div class="logo" @click="gotoIndex"></div>
    <ul class="main">
      <li @click="gotoClass"><img src="@/assets/icon/articlehead_icon_video.png" alt="课程">课程</li>
      <li @click="gotoExam"><img src="@/assets/icon/articlehead_icon_exam.png" alt="题库">题库</li>
      <li @click="gotoApp"><img src="@/assets/icon/articlehead_icon_app.png" alt="APP下载">APP下载</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'articleHead',
  data () {
    return {

    }
  },
  methods: {
    gotoClass () {
      this.$router.push({name: 'Jszg'})
    },
    gotoExam () {
      this.$router.push({name: 'ExamBank'})
    },
    gotoApp () {
      this.$router.push({name: 'AppDown'})
    },
    gotoIndex () {
      this.$router.push({name: 'Index'})
    }
  }
}
</script>

<style scoped lang="stylus">
  #articlehead
    display: flex
    justify-content: space-between
    align-items: center
    height: .94rem
    padding: 0 .2rem
    background-color: #1d91fc
    -webkit-background-size: 3.68rem .46rem
    background-size: 3.68rem .46rem
    div.logo
      width: 3.68rem
      height: .46rem
      background: url(../../../assets/img/articlehead_img_logo.png) no-repeat center #1d91fc
      -webkit-background-size: 100%
      background-size: 100%
    ul.main
      display: flex
      justify-content: space-between
      align-items: center
      width: 2.56rem
      height: .6rem
      li
        font-size: .2222rem
        color: #fff
        text-align: center
        img
          display: block
          width: .36rem
          height: .24rem
          margin: 0 auto .08rem
        &:nth-of-type(2)
          img
            width: .25rem
            height: .27rem
        &:nth-of-type(3)
          img
            width: .34rem
            height: .27rem
</style>



// WEBPACK FOOTER //
// src/components/share/header/articleHead.vue